export const MAX_EVENT_PRODUCTS_NUMBER = 6;

export const MAX_PRODUCT_IMAGES = 20;

export const MAX_PRODUCT_DESCRIPTION_LENGTH = 200;
